import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "addBtn",
    "broadcastWrapper",
    "episodeSelect",
    "link",
    "removeBtn",
    "rows",
    "rowTemplate"
  ]
  static values = { episodes: Array }

  connect () {
    this.baseHref = this.linkTarget.getAttribute("href")
    this.refreshEpisodeOptions()
  }

  addRow () {
    this.rowsTarget.insertAdjacentHTML("beforeend", this.rowTemplateTarget.innerHTML)
    this.addBtnTarget.style.display = "none"
    this.refreshEpisodeOptions()
  }

  episodeSelected (event) {
    const select = event.target
    const row = select.closest("[data-prefill-url-fields-target='row']")
    const wrapper = row.querySelector("[data-prefill-url-fields-target='broadcastWrapper']")
    const episodeId = select.value

    this.refreshEpisodeOptions()

    if (!episodeId) {
      wrapper.innerHTML = ""
      return
    }

    fetch(`/admin/episodes/${episodeId}/broadcast_options`)
      .then(r => r.text())
      .then(html => {
        wrapper.innerHTML = html

        const broadcastSelect = wrapper.querySelector("select")

        if (broadcastSelect) {
          broadcastSelect.addEventListener("change", e => this.broadcastSelected(e))
        }
      })
  }

  broadcastSelected (event) {
    const select = event.target

    const row = select.closest("[data-prefill-url-fields-target='row']")
    const removeBtn = row.querySelector("[data-prefill-url-fields-target='removeBtn']")
    if (removeBtn) removeBtn.style.display = "flex"

    this.updateLink()
    this.refreshEpisodeOptions()
  }

  refreshEpisodeOptions () {
    const used = new Set(
      this.episodeSelectTargets
          .map(el => el.value)
          .filter(v => v)
    )

    this.episodeSelectTargets.forEach(select => {
      Array.from(select.options).forEach(opt => {
        if (opt.value === "") return
        opt.hidden = used.has(opt.value) && opt.value !== select.value
      })
    })

    const allIds  = this.episodesValue.map(e => String(e.id))
    const hasFree = allIds.some(id => !used.has(id))
    this.addBtnTarget.style.display = hasFree ? "inline-block" : "none"

    this.checkMaxRowsReached()
  }

  updateLink () {
    const url = new URL(this.baseHref, window.location.origin)

    for (const key of url.searchParams.keys()) {
      if (key.startsWith("episode[")) {
        url.searchParams.delete(key)
      }
    }

    this.rowsTarget.querySelectorAll("[data-prefill-url-fields-target='row']").forEach(row => {
      const episodeId = row.querySelector("[data-prefill-url-fields-target='episodeSelect']").value
      const broadcastId = row.querySelector("select[name='broadcast_id']")?.value
      if (episodeId && broadcastId) url.searchParams.append(`episode[${episodeId}]`, `${broadcastId}`)
    })

    const href = url.toString().replace(/%5B/g, "[").replace(/%5D/g, "]")
    this.linkTarget.href = this.linkTarget.textContent = href
  }

  removeRow (event) {
    const row = event.target.closest("[data-prefill-url-fields-target='row']")
    row.remove()
    this.updateLink()
    this.refreshEpisodeOptions()
    this.addBtnTarget.style.display = "inline-block"
  }

  checkMaxRowsReached () {
    if (this.rowsTarget.querySelectorAll("[data-prefill-url-fields-target='row']").length >= this.episodesValue.length) {
      this.addBtnTarget.style.display = "none"
    }
  }
}
